export function ConfirmPurchase() {
  return (
    <div>
      You are purchasing influencer’s on behalf of brand, please ensure that you
      have sufficient proofs of purchase from the brand before confirming
    </div>
  );
}
